import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  deleteMentorNote: {
    id: 'ActivityEdit.DeleteMentorNote',
    defaultMessage: 'Delete this mentor note?'
  },
  deleteResource: {
    id: 'ActivityEdit.DeleteResource',
    defaultMessage: 'Delete this resource?'
  },
  deleteActivity: {
    id: 'Quest.Activity.DeleteActivity',
    defaultMessage: 'Are you sure you want to delete this activity?'
  }
})



// WEBPACK FOOTER //
// ./src/utils/messages/confirm.js